module.exports = __webpack_public_path__ + "02_very_short_brown.4fe2b4bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/02_very_short_brown.png
// module id = SPrr
// module chunks = 0